import { useEffect } from 'react';
import { environment } from '../../../environments/environment';
import {
  glassboxProd,
  glassboxRLS,
  glassboxUat,
} from './scripts/glassboxScript';

export const getGlassboxScript = () => {
  const glassboxEnv = environment.glassbox;

  switch (glassboxEnv) {
    case 'PROD':
      return glassboxProd;
    case 'RLS':
      return glassboxRLS;
    case 'UAT':
      return glassboxUat;
    default:
      return null;
  }
};

export const useGlassboxScript = () => {
  useEffect(() => {
    const glassboxConfig = getGlassboxScript();

    if (
      glassboxConfig &&
      glassboxConfig.src &&
      glassboxConfig.src.trim().length > 0
    ) {
      const onLoad = () => {
        if (document.getElementById('_cls_detector')) return;

        const script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.id = '_cls_detector';
        script.dataset.testid = '_cls_detector';
        script.src = glassboxConfig.src;

        if (glassboxConfig.dataClsconfig) {
          script.setAttribute('data-clsconfig', glassboxConfig.dataClsconfig);
        }

        document.head.appendChild(script);
      };

      window.addEventListener('load', onLoad);

      return () => {
        window.removeEventListener('load', onLoad);
        const script = document.getElementById('_cls_detector');
        if (script) {
          document.head.removeChild(script);
        }
      };
    }
    return undefined;
  }, []);
};
